class SmoothScrollLink extends HTMLElement {
  constructor() {
    super();
    this.link = this.querySelector('a');
    if (this.link) {
      this.link.addEventListener('click', this.onClick.bind(this));
    }
  }

  onClick(event) {
    const href = this.link.getAttribute('href');
    
    // Only intercept if it's an anchor link starting with #
    if (href && href.startsWith('#') && href.length > 1) {
      event.preventDefault();
      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        // Calculate header height
        const header = document.querySelector('.section-header');
        const stickyHeader = document.querySelector('sticky-header');
        
        let headerHeight = 0;
        if (header) {
          headerHeight = header.offsetHeight;
        } else if (stickyHeader) {
          headerHeight = stickyHeader.offsetHeight;
        }
        
        // Add a small buffer (e.g., 40px) to ensure the section isn't touching the header
        const buffer = 40;
        const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - headerHeight - buffer;
        
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      } else {
        console.warn('Target section with ID ' + targetId + ' not found.');
      }
    }
  }
}

customElements.define('smooth-scroll-link', SmoothScrollLink);
